import React, { type JSX } from 'react';

// Custom components
import BreadcrumbContainer from './BreadcrumbContainer/BreadcrumbContainer';
import PrimaryHeader from './PrimaryHeader/PrimaryHeader';
import ActionsHeader from './ActionsHeader/ActionsHeader';
import { ContextDataSlideOutProvider } from 'components/ExperienceCanvas/ContextDataSlideOut/ContextDataSlideOutContext';

// Types
import { JourneyState } from 'store/journey/journey.type';

// Stylings
import './HeaderLayout.scss';

type HeaderLayoutType = {
  journeyInstance: JourneyState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refetch: (showLoading?: any) => Promise<void>;
};

const HeaderLayout = ({ journeyInstance, refetch }: HeaderLayoutType): JSX.Element | null => {
  const primaryHeaderProps = {
    journeyInstance,
    refetch,
  };

  return (
    <ContextDataSlideOutProvider>
      <BreadcrumbContainer />
      <PrimaryHeader {...primaryHeaderProps} />
      <ActionsHeader journeyInstance={journeyInstance} showLocalizationSelector />
    </ContextDataSlideOutProvider>
  );
};

export default HeaderLayout;
